exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.word-cloud-wrap[data-v-116f6ec6] {\n  height: inherit;\n}\n", ""]);

// exports
